<template>
  <v-btn
    color="#FFD21F"
    light
    rounded
    outlined
    elevation="2"
    class="chat-btn"
    @click="openFreshchat"
  >
    <v-icon :left="!isMobile" color="#111111">
      mdi-headset
    </v-icon>

    <span v-if="!isMobile">
      Chat
    </span>
  </v-btn>
</template>

<script>
export default {
  name: "FreshChatButton",

  data() {
    return {
      isMobile: false,
      watcher: null,
    };
  },

  mounted() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);

    this.hideFreshchatFrame();
    this.startFreshchatWatcher();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);

    if (this.watcher) {
      clearInterval(this.watcher);
      this.watcher = null;
    }
  },

  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 600;
    },

    openFreshchat() {
      this.waitForFreshchat()
        .then(() => {
          this.showFreshchatFrame();

          if (
            window.fcWidget &&
            typeof window.fcWidget.show === "function"
          ) {
            window.fcWidget.show();
          }

          setTimeout(() => {
            if (
              window.fcWidget &&
              typeof window.fcWidget.open === "function"
            ) {
              window.fcWidget.open();
            }
          }, 150);
        })
        .catch(() => {
          console.warn("Freshchat no está disponible todavía.");
        });
    },

    startFreshchatWatcher() {
      if (this.watcher) {
        clearInterval(this.watcher);
      }

      this.watcher = setInterval(() => {
        const frame = document.getElementById("fc_frame");

        if (!window.fcWidget || !frame) {
          return;
        }

        const isOpen =
          typeof window.fcWidget.isOpen === "function"
            ? window.fcWidget.isOpen()
            : false;

        if (isOpen) {
          this.showFreshchatFrame();
        } else {
          this.hideFreshchatFrame();
        }
      }, 300);
    },

    showFreshchatFrame() {
      const frame = document.getElementById("fc_frame");

      if (!frame) {
        return;
      }

      frame.style.display = "block";
      frame.style.visibility = "visible";
      frame.style.opacity = "1";
      frame.style.zIndex = "999999";
      frame.style.pointerEvents = "auto";
    },

    hideFreshchatFrame() {
      const frame = document.getElementById("fc_frame");

      if (!frame) {
        return;
      }

      frame.style.display = "none";
      frame.style.visibility = "hidden";
      frame.style.opacity = "0";
      frame.style.pointerEvents = "none";
    },

    waitForFreshchat() {
      return new Promise((resolve, reject) => {
        let attempts = 0;

        const interval = setInterval(() => {
          attempts++;

          const hasWidget =
            window.fcWidget &&
            typeof window.fcWidget.open === "function";

          const hasFrame = document.getElementById("fc_frame");

          if (hasWidget && hasFrame) {
            clearInterval(interval);
            resolve();
          }

          if (attempts >= 40) {
            clearInterval(interval);
            reject();
          }
        }, 250);
      });
    },
  },
};
</script>

<style scoped>
.chat-btn {
  text-transform: none !important;
  font-weight: 800;
  letter-spacing: 0.3px;
  min-width: 90px;
  height: 36px !important;
  padding: 0 16px !important;
  border-radius: 22px !important;
  white-space: nowrap;
  color: #111111 !important;
  background-color: #ffd21f !important;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.25) !important;
}

.chat-btn:hover {
  background-color: #ffc400 !important;
}

.chat-btn span {
  color: #111111 !important;
}

.chat-btn .v-icon {
  color: #111111 !important;
}

/* Mobile: solo icono */
@media (max-width: 599px) {
  .chat-btn {
    min-width: 40px !important;
    width: 40px !important;
    height: 40px !important;
    padding: 0 !important;
    border-radius: 50% !important;
  }

  .chat-btn .v-icon {
    margin: 0 !important;
  }
}
</style>